import { useAuthStore } from '@manager/store/auth-store';
import { usePermissionStore } from '@manager/store/permission-store';
import { computed } from 'vue';

export function useUser() {
  const authStore = useAuthStore();
  const user = computed(() => authStore.user || undefined);
  const permissionsStore = usePermissionStore();
  const permissions = computed(() => permissionsStore.permissions || []);

  return {
    user,
    permissions,
    id: computed(() => user.value?.id),
    firstName: computed(() => user.value?.firstname),
    fullName: computed(() => {
      if (!user.value) {
        return 'Kinnovis';
      }
      return [user.value?.firstname, user.value?.lastname]
        .filter((name) => !!name)
        .join(' ');
    }),
    initials: computed(() => {
      if (!user.value) {
        return 'KN';
      }
      return [user.value?.firstname?.charAt(0), user.value?.lastname.charAt(0)]
        .filter((name) => !!name)
        .join('');
    }),
    email: computed(() => {
      return user.value?.email || 'office@kinnovis.com';
    }),
    tenantName: computed(() => user.value?.tenant_name),
    tenantId: computed(() => user.value?.tenant_id),
    multiDomainEnabled: computed(
      () => !!user.value?.tenant_features?.allow_location_domain
    ),
    hasPublicApiEnabled: computed(
      () => !!user.value?.tenant_features?.has_public_api_enabled
    ),
    currency: computed(() => user.value?.currency),
    isKinnovisBillingUser: computed(
      () => !!user.value?.tenant_features?.uses_kinnovis_billing
    ),
    isKinnovisInvoicingUser: computed(
      () => !!user.value?.tenant_features?.uses_kinnovis_invoicing
    ),
    isBlockedForMigration: computed(
      () => !!user.value?.tenant_features?.is_blocked_for_migration
    ),
  };
}
